'use strict';

import config from '../config';

module.exports = function(Handlebars) {
  let tagPrefix = 'data-gtm-';
  let valueSeparator = ' - ';
  let getEventTypeValue = (event_) => {
    return config.analytics.eventTypes[event_]
  }
  let getActionValue = (action) => {
    switch (action) {
      case config.analytics.actions.RegionSelect: return 'Region Select';
      case config.analytics.actions.EngineerContact: return 'Engineer Contact';
      case config.analytics.actions.ArrowCom: return 'Arrow.com';
      case config.analytics.actions.BannerClick: return 'BannerClick';
      case config.analytics.actions.AddFilter: return 'Add Filter';
      case config.analytics.actions.RemoveFilter: return 'Remove Filter';
      case config.analytics.actions.AddToCartSuccess: return `Add to Cart${valueSeparator}Success`;
      case config.analytics.actions.AddToCartFail: return `Add to Cart${valueSeparator}Fail`;
      case config.analytics.actions.AddToCart: return 'Add to Cart';
      case config.analytics.actions.LanguageSelect: return 'Language Select';
      case config.analytics.actions.CurrencySelect: return 'Currency Select';
      case config.analytics.actions.DivisionSelect: return 'Division Select';
      case config.analytics.actions.CallForPrice: return 'Call for Price';
      case config.analytics.actions.RemoveFromCart: return 'Remove from Cart';
      case config.analytics.actions.NoSearchResults: return 'No Search Results';
      case config.analytics.actions.BannerImpression: return 'Banner Impression';
      case config.analytics.actions.LaunchTool: return 'Launch Tool';
      case config.analytics.actions.GetStarted: return 'Get Started';
      case config.analytics.actions.SaveToProject: return 'Save to Project';
      case config.analytics.actions.LoginAttempt: return 'Login Attempt';
      case config.analytics.actions.CreateProject: return 'Create Project';
      case config.analytics.actions.DuplicateProject: return 'Duplicate Project';
      case config.analytics.actions.DeleteProject: return 'Delete Project';
      case config.analytics.actions.ClickEcommerce: return 'click';
      case config.analytics.actions.SearchBar: return 'Search Bar';
      case config.analytics.actions.ErrorBar: return 'Error Bar';
      case config.analytics.actions.JumpLinkClick: return 'Jump Link Click';
      default: return config.analytics.actions[action];
    }
  };
  let getCategoryValue = (category) => {
    switch (category) {
      case config.analytics.categoryTypes.DesignCenter: return 'Design Center';
      case config.analytics.categoryTypes.MyProjects: return 'My Projects';
      case config.analytics.categoryTypes.ResearchAndEvents: return 'Research & Events';
      case config.analytics.categoryTypes.ManufacturerList: return 'Manufacturer List';
      case config.analytics.categoryTypes.ReferenceDesigns: return 'Reference Designs';
      case config.analytics.categoryTypes.SiteMode: return 'Site Mode';
      case config.analytics.categoryTypes.UiInteraction: return 'UI Interaction';
      case config.analytics.categoryTypes.ProductCategory: return 'Product Category';
      case config.analytics.categoryTypes.ProductDetail: return 'Product Detail';
      default: return config.analytics.categoryTypes[category];
    }
  };
  let getLabelValue = (label) => {
    switch (label) {
      case config.analytics.labelTypes.VideoChat: return 'Video Chat';
      case config.analytics.labelTypes.CartIcon: return 'Cart Icon';
      case config.analytics.labelTypes.CurrencySelector: return 'Currency Selector';
      case config.analytics.labelTypes.ArrowDivisions: return 'Arrow Divisions';
      case config.analytics.labelTypes.LanguageSelector: return 'Language Selector';
      case config.analytics.labelTypes.LoggedIn: return 'Logged In';
      case config.analytics.labelTypes.LoginSignup: return 'Login-Signup';
      case config.analytics.labelTypes.ViewCart: return 'View Cart';
      case config.analytics.labelTypes.ForgotPassword: return 'Forgot Password';
      case config.analytics.labelTypes.DesignWithEnvision: return 'Design with Envision';
      case config.analytics.labelTypes.DesignWithOrCad: return 'Design with OrCad';
      case config.analytics.labelTypes.DatasheetText: return 'Datasheet Text';
      case config.analytics.labelTypes.MissingImage: return 'Missing Image';
      case config.analytics.labelTypes.NewProject: return 'New Project';
      case config.analytics.labelTypes.CurrentProject: return 'Current Project';
      case config.analytics.labelTypes.SelectedProject: return 'Selected Project';
      case config.analytics.labelTypes.GooglePlus: return 'Google Plus';
      case config.analytics.labelTypes.NoSearchResults: return 'No search Results';
      case config.analytics.labelTypes.GoToArrow: return 'Go to Arrow.com';
      case config.analytics.labelTypes.GoToMyArrow: return `Go to MyArrow${valueSeparator}region`;
      case config.analytics.labelTypes.UserLockedOut: return 'Locked Out';
      case config.analytics.labelTypes.ViewAll: return 'View All';
      case config.analytics.labelTypes.RelatedProducts: return 'Related Products';
      case config.analytics.labelTypes.CrossReferences: return 'Cross References';
      case config.analytics.labelTypes.SecureCheckout: return 'Secure Checkout';
      default: return config.analytics.labelTypes[label];
    }
  };
  Handlebars.registerHelper('analytics_events', function(options) {
    let returnString = '';
    let mediator;
    let action;
    let actionOff;
    let category;
    let event_ = config.analytics.eventTypes.Click;
    let label = config.analytics.labelTypes.Dynamic;
    if (typeof options.mediator !== 'undefined') {
      mediator = options.mediator;
    }
    if (typeof options.action !== 'undefined') {
      action = options.action;
    }
    if (typeof options.actionOff !== 'undefined') {
      actionOff = options.actionOff;
    }
    if (typeof options.category !== 'undefined') {
      category = options.category;
    }
    if (typeof options.event !== 'undefined') {
      event_ = options.event;
    }
    if (typeof options.label !== 'undefined') {
      label = options.label;
    }
    if (event_) {
      event_ = getEventTypeValue(event_);
      returnString += tagPrefix + config.analytics.eventAttributeNames.action + '="' + Handlebars.escapeExpression(event_) +  '"';
    }
    if (action) {
      action = getActionValue(action);
      returnString += tagPrefix + config.analytics.eventAttributeNames.action + '="' + Handlebars.escapeExpression(action) +  '"';
    }
    if (actionOff) {
      actionOff = getActionValue(actionOff);
      returnString += tagPrefix + config.analytics.eventAttributeNames.actionOff + '="' + Handlebars.escapeExpression(actionOff) +  '"';
    }
    if (category) {
      category = getCategoryValue(category);
      returnString += tagPrefix + config.analytics.eventAttributeNames.category + '="' + Handlebars.escapeExpression(category) +  '"';
    }
    if (label || typeof options.dynamicLabel !== 'undefined') {
      if (typeof options.dynamicLabel !== 'undefined') {
        label = options.dynamicLabel;
      }
      else {
        label = getLabelValue(label);
      }
      returnString += tagPrefix + config.analytics.eventAttributeNames.label + '="' + Handlebars.escapeExpression(label) +  '"';
    }
    if (mediator) {
      returnString += tagPrefix + config.analytics.eventAttributeNames.mediator + '="' + Handlebars.escapeExpression(mediator) +  '"';
    }
    return Handlebars.SafeString(returnString);
  });
};



// WEBPACK FOOTER //
// ./assets/js/handlebars-helpers/ArrowAnalytics.js